import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'

export const V2UserConfigDict = {
	enabled: {
		label: 'Verrechnungsergebnisse',
		type: 'boolean',
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.v2Default, propDefaultFalse),
		visibleSelector: selPropGen(PropID.v2Vis, propDefaultTrue),
	},
} as const